import React, { useEffect, useReducer, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import useAxios from "../hooks/useAxios";
import { getError, getUnitLabel, round2 } from "../utils";
import LoadingBox from "./LoadingBox";
import ProductTable from "./ProductTable";

const reducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_REQUEST":
      return { ...state, loadingUpdate: true };
    case "UPDATE_SUCCESS":
      return { ...state, loadingUpdate: false };
    case "UPDATE_FAIL":
      return { ...state, loadingUpdate: false };

    default:
      return state;
  }
};

export default function StockInputEditorModal(props) {
  const axios = useAxios();
  const {
    showEditor,
    setShowEditor,
    features,
    stock,
    productId,
    setName,
    setUnit,
    setFeatures,
    setProductId,
    userInfo,
    name,
    unit,
    setOperationSuccessfull,
    isUpdate,
  } = props;

  const [paymentType, setPaymentType] = useState("CACHE");
  const [price, setPrice] = useState(null);
  const [amount, setAmount] = useState();
  const [feature, setFeature] = useState("");
  const [featureId, setFeatureId] = useState("");
  const [stockId, setStockId] = useState("");

  useEffect(() => {
    setPaymentType(stock.paymentType);
    setPrice(stock.price);
    setAmount(stock.amount);
    setFeature(stock.feature);
    setFeatureId(stock.featureId);
    setStockId(stock._id);
  }, [stock]);

  const [{ loadingUpdate }, dispatch] = useReducer(reducer, {
    loading: true,
    error: "",
  });

  const productAddHandler = (p, feature) => {
    setProductId(p._id);
    setName(p.name);
    setUnit(p.unit);
    setFeatures(p.features);
  };

  const inputStockHandler = async (e) => {
    e.preventDefault();
    try {
      if (!productId) {
        toast.error("Lutfen bir urun seciniz");
        return;
      }
      if (features && features.length > 0 && feature === "") {
        toast.error("Lutfen bir urun cesidi seciniz");
        return;
      }

      if (!amount || amount === 0) {
        toast.error("Lutfen miktar giriniz");
        return;
      }

      if (!price || price === 0) {
        toast.error("Lutfen tutar  giriniz");
        return;
      }
      dispatch({ type: "UPDATE_REQUEST" });
      const { data } = stockId
        ? await axios.put(`/api/stock/inputStock/${productId}`, {
            _id: stockId,
            price: round2(Number(price)),
            amount,
            unit: unit || "ADET-1",
            feature,
            featureId,
            paymentType,
          })
        : await axios.post(`/api/stock/inputStock/${productId}`, {
            price: round2(Number(price)),
            amount,
            unit,
            feature,
            featureId,
            paymentType,
          });

      //const { data: data2 } = await axios.get(`/api/products/${productId}`);
      /*const { data: stockData } = await axios.get(
        `/api/stock/stockInputs/${productId}`
      );*/

      setPrice("");
      setAmount("");
      setFeature("");
      setFeatureId(null);
      setOperationSuccessfull(true);
      //setFeatures(data2.features);
      //setStockInputs(stockData);
      setShowEditor(false);
      dispatch({
        type: "UPDATE_SUCCESS",
        payload: data,
      });

      toast.success("Stok basarili bir sekilde olusturuldu");
    } catch (err) {
      setShowEditor(false);
      toast.error(getError(err));
      dispatch({ type: "UPDATE_FAIL" });
    }
  };

  return (
    <div>
      <Modal
        show={showEditor}
        onHide={() => setShowEditor(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {stockId ? "Stok Güncelle" : "Yeni Stok Girişi"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!isUpdate && !productId && (
            <ProductTable
              type={"menu"}
              productAddHandler={productAddHandler}
            ></ProductTable>
          )}
          {name && <h5 className="mb-3">{name + " "} için stok girişi</h5>}
          {!isUpdate && productId && (
            <>
              <div className="mb-3">
                <Link
                  to=""
                  className="textDecorationNone"
                  onClick={() => {
                    setProductId(null);
                    setName("");
                    setFeatures([]);
                  }}
                >
                  {" "}
                  Başka bir ürün seçmek için{" "}
                  <span style={{ textDecoration: "underline" }}>
                    tıklayınız
                  </span>
                </Link>
              </div>
            </>
          )}
          {productId && features && features.length > 0 && (
            <Form.Group className="mb-3">
              <Row>
                <Col>
                  <Form.Select
                    onChange={(e) => {
                      const value = JSON.parse(e.target.value);
                      setFeature(value.name);
                      setFeatureId(value._id);
                    }}
                  >
                    <option value={""}>Bir ürün çeşidi seçiniz!</option>
                    {features.map((c) => (
                      <option value={JSON.stringify(c)} key={c._id}>
                        {c.name}&nbsp;{name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Row>
            </Form.Group>
          )}
          {productId && (
            <>
              <Form.Group className="mb-3">
                <Row>
                  <Col xs={9}>
                    <Form.Control
                      value={amount}
                      placeholder="Miktar Gir"
                      type="number"
                      onChange={(e) => setAmount(e.target.value)}
                      required
                    />
                  </Col>
                  <Col xs={3}>
                    <span>
                      <i className="fas fa-times"></i>
                    </span>
                    &nbsp;&nbsp;
                    <span>{getUnitLabel(unit)}</span>
                  </Col>
                </Row>
              </Form.Group>

              <Form.Group className="mb-3">
                <Row>
                  <Col>
                    <Form.Control
                      value={price}
                      placeholder="Tutar Gir"
                      type="number"
                      onChange={(e) => setPrice(e.target.value)}
                      required
                    />
                  </Col>
                </Row>
              </Form.Group>

              <Form.Group>
                <Form.Check
                  style={{ display: "inline-block" }}
                  type="checkbox"
                  label="Nakit Odeme?"
                  value={paymentType === "CACHE"}
                  checked={paymentType === "CACHE"}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setPaymentType("CACHE");
                    } else {
                      setPaymentType("POS");
                    }
                  }}
                />
                &nbsp;
                <span className="text-secondary">
                  {paymentType === "CACHE"
                    ? "Nakit odeme sectiniz!"
                    : "Pos ile odeme sectiniz!"}
                </span>
              </Form.Group>
            </>
          )}

          <div className="mt-3">
            {loadingUpdate && <LoadingBox></LoadingBox>}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditor(false)}>
            Kapat
          </Button>
          <Button disabled={loadingUpdate} onClick={inputStockHandler}>
            {stockId ? "Stok Guncelle" : "Stok Gir"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
